import { delay, call, put, select, takeEvery } from 'redux-saga/effects';
import * as performersActions from '../../actions/performers/getAllPerformers';
import { getAllPerformersRequest } from '../../../api/performers/getAllPerformers';
import history from '../../../../../common/history';

const getActiveProfileId = state => {
  return (
    state.Authorization &&
    state.Authorization.activeProfile &&
    state.Authorization.activeProfile.profileId
  );
};

function* getAllPerformers(action) {
  let activeProfileId = yield select(getActiveProfileId);
  if (activeProfileId) {
    try {
      delay(1000);
      const response = yield call(getAllPerformersRequest, activeProfileId);
      let performerTypes = {};
      let performersStat = {};
      response.forEach(item => {
        if (item.status.statusKey) {
          const { statusKey } = item.status;
          if (!performerTypes.hasOwnProperty(statusKey)) {
            performerTypes[statusKey] = {
              key: statusKey,
              status: item.status.name,
            };
          }
          performersStat.hasOwnProperty(statusKey)
            ? performersStat[statusKey]++
            : (performersStat[statusKey] = 1);
        }
      });
      yield put(
        performersActions.getAllPerformersSuccess({
          performers: response,
          performerTypes: Object.keys(performerTypes).map(
            key => performerTypes[key]
          ),
          performersStat,
        })
      );
    } catch (e) {
      yield put(performersActions.getAllPerformersFailure(e));
    }
  } else {
    yield delay(500);
    activeProfileId = yield select(getActiveProfileId);
    activeProfileId
      ? yield put(performersActions.getAllPerformers(activeProfileId))
      : history.push('/authorization/profiles');
  }
}

export function* performersWatcher() {
  yield takeEvery(
    performersActions.getAllPerformers.toString(),
    getAllPerformers
  );
}
